import React, { useCallback, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import BasicTextFields from "./addComment/addComment";
import AutoGridNoWrap from "./showComments/showComment";
import ShowWorklog from "../../worklog/showWorklog";
import "./detailGrid.scss";
import Description from "./description/description";
import SidebarGrid from "../sidebar/sidebar";
import AttachmentCard from "../showDetailAttachment/showDetailAttachment";
import History from "./history";
import AllDetail from "./showAllDetail/AllDetail";
import EditTitle from "./editTitle";
import { currentUserId, isAdmin } from "../../../../../utils/constants";
import { useCard } from "../../../../../utils/reactQuery/cards";
import { useResponsive } from "../../../../../hooks/useResponsive";
import Chatbot from "../sidebar/components/Chatbot";
import Activity from "./Activity";

function BasicGrid({
  cardId,
  description,
  title,
  data,
  cardDescription,
  isfocus,
  handleDescriptionSave,
  setCardTitle,
  boardPermission,
}) {
  const [activeTab, setActiveTab] = useState("all");
  const [textEditor, setTextEditer] = useState(false);
  const [aiEnabled, setAiEnabled] = useState(false);

  const {
    assigned_to_user_id,
    board: { owner_user_id: boardOwnerId },
    is_card_collaborator,
  } = data;

  const isMobile = useResponsive("down", "md");
  const {
    isLoading: isCardLoading,
    card,
    isError: isCardError,
  } = useCard(cardId);

  const addWorklogPermission = useMemo(
    () =>
      isAdmin() ||
      boardOwnerId == currentUserId() ||
      boardPermission?.is_admin ||
      (assigned_to_user_id == currentUserId() && boardPermission?.can_add_work_log && (Boolean(card?.data?.data?.responseData?.allocated_hours) || boardPermission?.can_work_before_estimation)) ||
      is_card_collaborator,
    [boardOwnerId, boardPermission, assigned_to_user_id, is_card_collaborator]
  );

  const conditionCheck = useMemo(() => (
    isAdmin() ||
    boardOwnerId === currentUserId() ||
    boardPermission?.is_admin ||
    (card?.data?.data?.responseData?.assigned_to_user_id == currentUserId() && boardPermission?.can_edit_task) ||
    card?.data?.data?.responseData?.reporter === currentUserId()
  ), [boardOwnerId, boardPermission, card]);

  const handleActiveTab = useCallback((activeItem) => {
    setActiveTab(activeItem);
  }, []);

  const handleTextEditor = useCallback(() => {
    if (
      isAdmin() ||
      boardOwnerId == currentUserId() ||
      data?.reporter == currentUserId()
    ) {
      setTextEditer(true);
    }
  }, [boardOwnerId, data]);

  const toggleChatbotVisibility = useCallback(() => {
    setAiEnabled((prevState) => !prevState);
  }, []);

  const handleSetTextEditor = useCallback(() => {
    setTextEditer(false);
  }, []);
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2}>
        <Grid
          item
          xs={isMobile ? 12 : 8}
          sx={{
            // height: "100vh",
            overflowY: "auto",
            paddingTop: isMobile ? "8px !important" : "",
            paddingBottom: isMobile ? "100px !important" : "0",
          }}
        >
          <div>
            <EditTitle
              cardId={cardId}
              title={title}
              id={data?.board?.board_id}
              hasEditCardPermission={conditionCheck}
            />
            <div className="description description-mobile-label">
              Description
            </div>

            <Description
              description={description}
              setTextEditer={handleSetTextEditor}
              handleTextEditor={handleTextEditor}
              accessToUpdate={conditionCheck} 
              cardDescription={cardDescription}
              isfocus={isfocus}
              handleDescriptionSave={handleDescriptionSave}
              toggleChatbotVisibility={toggleChatbotVisibility}
            />

            <AttachmentCard cardId={cardId} />
            {isMobile ? (
              aiEnabled ? (
                <Chatbot
                  cardData={card?.data?.data?.responseData}
                  toggleChatbotVisibility={toggleChatbotVisibility}
                  cardDescription={cardDescription}
                  setCardTitle={setCardTitle}
                />
              ) : (
                <SidebarGrid
                  cardId={cardId}
                  boardPermission={boardPermission}
                />
              )
            ) : (
              ""
            )}
            <Activity
              activeTab={activeTab}
              handleActiveTab={handleActiveTab}
              isMobile={isMobile}
              addWorklogPermission={addWorklogPermission}
              cardId={cardId}
            
            />
            {activeTab === "all" && (
              <div>
                <AllDetail cardId={cardId}  
                 boardPermission={boardPermission} />
              </div>
            )}
            {activeTab === "comment" && (
              <div>
                <BasicTextFields cardId={cardId} />
                <div>
                  <AutoGridNoWrap cardId={cardId} />
                </div>
              </div>
            )}
            {activeTab === "worklog" && (
              <div>
                <ShowWorklog
                  textEditor={textEditor}
                  cardId={cardId}
                  boardPermission={boardPermission}
                  isMobile={isMobile}
                  addWorklogPermission={addWorklogPermission}
                />
              </div>
            )}
            {activeTab === "history" && <History cardId={cardId} />}
          </div>
        </Grid>
        <Grid item xs={isMobile ? 12 : 4}>
          {!isMobile ? (
            aiEnabled ? (
              <Chatbot
                cardData={card?.data?.data?.responseData}
                toggleChatbotVisibility={toggleChatbotVisibility}
                cardDescription={cardDescription}
                setCardTitle={setCardTitle}
              />
            ) : (
              <>
                <SidebarGrid
                  cardId={cardId}
                  boardPermission={boardPermission}
                />
              </>
            )
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default React.memo(BasicGrid);
